import { Button, Card, Col, Drawer, Form, Icon, Input, notification, Popconfirm, Row, Table } from 'antd'
import React from 'react'
import { connect } from 'react-redux'
import { formItemLayout } from '../../../components/_utils/appUtils'
import { updateApprovedAbstractFxn } from '../actions'

@Form.create()
class AbstractFAQDrawer extends React.Component {
  state = {
    faqs: [],
    loading: false
  }

  componentDidMount() {
    if (this.props.abstract) {
      this.setState({ faqs: this.props.abstract.faq || [] })
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.abstract !== prevProps.abstract) {
      this.setState({ faqs: this.props.abstract.faq || [] })
    }
  }

  handleSubmit = e => {
    e.preventDefault()
    const { form, abstract, dispatch, onRefresh } = this.props
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        if (!valData.faqQuestion || !valData.faqAnswer) {
          notification.error({
            message: 'Missing Fields',
            description: 'Please fill in both Question and Answer fields.'
          })
          return
        }
        this.setState({ loading: true })
        const newFaq = {
          question: valData.faqQuestion,
          answer: valData.faqAnswer
        }
        const updatedFaqs = [...this.state.faqs, newFaq]

        let fd = new FormData()
        fd.append('obj', JSON.stringify({
          abstractId: abstract._id,
          faqs: updatedFaqs
        }))

        let response = await dispatch(updateApprovedAbstractFxn(fd))
        this.setState({ loading: false })

        if (response && response.success) {
          form.resetFields()
          if (onRefresh) onRefresh()
        }
      }
    })
  }

  removeFaqSubmit = async index => {
    const { abstract, dispatch, onRefresh } = this.props
    const updatedFaqs = [...this.state.faqs]
    updatedFaqs.splice(index, 1)

    this.setState({ loading: true })
    let fd = new FormData()
    fd.append('obj', JSON.stringify({
      abstractId: abstract._id,
      faqs: updatedFaqs
    }))

    let response = await dispatch(updateApprovedAbstractFxn(fd))
    this.setState({ loading: false })

    if (response && response.success) {
      if (onRefresh) onRefresh()
    }
  }

  render() {
    const { faqs, loading } = this.state
    const { form: { getFieldDecorator }, visible, onClose, abstract } = this.props

    const columns = [
      {
        title: 'Question',
        dataIndex: 'question',
        key: 'question',
        width: '30%'
      },
      {
        title: 'Answer',
        dataIndex: 'answer',
        key: 'answer',
        render: (text) => <div dangerouslySetInnerHTML={{ __html: text }} />
      },
      {
        title: 'Action',
        key: 'action',
        width: '80px',
        render: (text, record, index) => (
          <Popconfirm title='Sure to delete?' onConfirm={() => this.removeFaqSubmit(index)}>
            <a style={{ color: 'red' }}><Icon type='delete' /></a>
          </Popconfirm>
        )
      }
    ]

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        width={'60%'}
        title={`Manage FAQs | Abstract No. - ${abstract.abstractNo || 'N/A'}`}
        destroyOnClose
      >
        <Card bordered={false}>
          <Form onSubmit={this.handleSubmit} className={'inputForm'}>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item label="Question" {...formItemLayout}>
                  {getFieldDecorator('faqQuestion', {
                    initialValue: ''
                  })(
                    <Input placeholder="Enter FAQ question" />
                  )}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Answer" {...formItemLayout}>
                  {getFieldDecorator('faqAnswer', {
                    initialValue: ''
                  })(
                    <Input.TextArea rows={4} placeholder="Enter FAQ answer (You can use simple HTML tags if needed)" />
                  )}
                </Form.Item>
              </Col>
              <Col span={24} style={{ marginBottom: '20px' }}>
                <Form.Item>
                  <Button type="primary" htmlType="submit" loading={loading} block>
                    <Icon type="plus" /> Add FAQ to List
                  </Button>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Table
                  columns={columns}
                  dataSource={faqs}
                  pagination={false}
                  size="small"
                  bordered
                  rowKey={(r, i) => i}
                />
              </Col>
            </Row>
          </Form>
        </Card>
      </Drawer>
    )
  }
}

export default connect(null)(AbstractFAQDrawer)
